import { useAuthStore } from "@/stores/auth.store";
import { useMenuStore } from "@/stores/menu.store";
import { useTabsStore } from "@/stores/tabs.store";
import i18n from "@/locales/translations";
import { useNotify } from "nvd-u/composables/Notifiy";

export function ensureLoggedInForSchemaEdit(message = 'Please log in to edit this schema.') {
    const auth = useAuthStore()
    const tabs = useTabsStore()
    const menu = useMenuStore()
    const notify = useNotify()

    if (menu.embedded) {
        return false
    }

    if (tabs.selectedTab && (tabs.isSchemaReadonly || tabs.isTemplateReadonly)) {
        const description = tabs.isTemplateReadonly
            ? i18n.global.t('project_status.template_schema_cannot_edit')
            : i18n.global.t('project_status.schema_readonly_access')
        notify.error(i18n.global.t('dialog.view_only'), description)
        return false
    }

    if (auth.isLoggedIn) return true

    menu.toggleLoginModal(true)
    notify.error('Login required', message)
    return false
}
